import React from "react";
import { IonIcon } from "@ionic/react";
import { chevronForward } from "ionicons/icons";
import styles from "./CurrentShippingAddress.module.scss";
import classNames from "classnames/bind";
import { CurrentShippingAddressSelect } from "./CurrentShippingAddressSelect";

const cx = classNames.bind(styles);

interface CurrentShippingAddressProps {
  selectColor?: string;
}

const CurrentShippingAddress = ({ selectColor }: CurrentShippingAddressProps) => {
  return (
    <div className={cx("wrapper")}>
      <CurrentShippingAddressSelect selectColor={selectColor} />
      <IonIcon className={cx("icon")} icon={chevronForward} />
    </div>
  );
};

export { CurrentShippingAddress };
